import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/* API */
import ReservationService from 'api/ReservationService';

/* Layout */
import './FormComponent.scss';
import PrimaryButton from 'util/PrimaryButton';
import SecondaryButton from 'util/SecondaryButton';
import { Container, Row, Col } from 'react-bootstrap';
import LoadingSpinner from 'util/LoadingSpinner';

const ReservationCancelComponent: React.FC = () => {
  const navigate = useNavigate();
  const { reservationId } = useParams();
  const [hasDeleted, setHasDeleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClickReservationCancel = async () => {
    setIsLoading(true);

    try {
      const result = await ReservationService.deleteReservation(reservationId || '');
      if (!result.reservationId) {
        setHasDeleted(false);
        return;
      }
      setHasDeleted(true);
    } catch (error) {
      setHasDeleted(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickReservationDetail = () => {
    navigate(`/reservation-detail/${reservationId}`);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!hasDeleted) {
    navigate('/404');
  }
  return (
    <>
      <Container className="pt-4">
        <Row className="justify-content-center">
          <Col className="text-center">
            {!hasDeleted ? (
              <>
                <p>予約をキャンセルします。</p>
                <p>本当によろしいですか？</p>
              </>
            ) : (
              <p>予約をキャンセルしました。</p>
            )}
          </Col>
        </Row>
      </Container>
      <Container className="pt-4">
        <Row className="justify-content-center">
          <Col xs={5}>
            <SecondaryButton
              label="戻る"
              type="button"
              className="w-100 mt-1 mb-4"
              onClick={handleClickReservationDetail}
            />
          </Col>
          {!hasDeleted && (
            <Col xs={5}>
              <PrimaryButton
                label="確定"
                type="button"
                className="w-100 mt-1 mb-4"
                onClick={handleClickReservationCancel}
              />
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
};

export default ReservationCancelComponent;
